const state = {
  gridList: [],
  sortBy: "CreatedOn",
  sortOrder: "DESC",
  plan: null,
  categoryNames: [],
  store: {},
  searchQuery: "",
  tblLoader: false,
  formLoader: false,
  selectedSiteId: null,
  isLoading: false,
};

export default state;
